const createOptions = (start, end, labelPrefix, valuePrefix = '') =>
  Array.from({ length: end - start + 1 }, (_, i) => i + start).map((num) => ({
   label: `${num.toString().padStart(2, '0')} ${labelPrefix}${num !== 1 ? 'es' : ''}`,
   value: valuePrefix ? `${valuePrefix}${num}` : num,
  }));
 
 const createNumberOptions = (start, end) =>
  Array.from({ length: end - start + 1 }, (_, i) => i + start).map((num) => ({
   label: num.toString().padStart(2, '0'),
   value: num,
  }));
 
 const MAX_LEVELS = 5;
 const MAX_THEMES = 12;
 const MAX_PILLARS = 5;
 
 export const levelOptions = createNumberOptions(1, MAX_LEVELS);
 
// EG-42 — optionsNumCertificationPilares REMOVIDO (com MAX_CERTIFICATION_PILLARS).
// Alimentava o select "Número de pilares" da certificação, que saiu da tela pela
// decisão D7: a quantidade de pilares passou a ser consequência dos templates
// importados, não uma escolha do gestor. optionsNumPilares FICA — o diagnóstico
// ainda o usa em três telas.
 
 export const numberOfThemesOptions = createNumberOptions(1, MAX_THEMES);
 
 export const optionsNumPilares = createOptions(1, MAX_PILLARS, 'pilar');
 
 export const periodicityOptions = [
  { label: 'Mensal', value: 'monthly' },
  { label: 'Trimestral', value: 'trimestral' },
  { label: 'Semestral', value: 'semester' },
  { label: 'Anual', value: 'annual' },
 ];
 